import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Context from "../../context";
import DocumentViewerScreen from "../global/DocumentViewer";
import { applyBackgroundImage } from "../../helpers/ui";

const DocumentViewer = ({ type }) => {
  const [data, setData] = useState(null);
  const [dailyBgNodeId, setDailyBgNodeId] = useState(null);

  const { itin } = useContext(Context);
  const { slideNum, docId } = useParams();

  useEffect(() => {
    const dayData = itin.brief[parseInt(slideNum) - 1];
    const documentItems = dayData.menu.filter(item => item.segue === 'documents' && item.segueId) ?? [];
    const dayDocuments = itin.documents.filter(doc => documentItems.some(item => item.segueId === doc.id && doc.type !== 'remote'));

    let dayDocsData = [...dayDocuments];
    if (dayData?.locationId) {
      const location = itin.locations.find(loc => loc.id === dayData?.locationId);
      const locationPdfNode = itin.documents.find(doc => doc.id === location.pdfNodeId);
      if (locationPdfNode) dayDocsData = [...dayDocuments, locationPdfNode];
    }

    if (type === "poiDocuments" && parseInt(docId)) {
      const poiDoc = itin.documents.find(doc => doc.id === parseInt(docId));
      if (poiDoc) dayDocsData = [...dayDocsData, poiDoc];
    }
    setDailyBgNodeId(dayData?.imageNodeId);
    setData(dayDocsData);
  }, [slideNum, itin.brief, itin.documents, itin.locations, type, docId]);

  useEffect(() => {
    if (!dailyBgNodeId) return;
    const mainBgUrl = itin?.photoNode?.file?.httpsUrl;
    const dailyBgUrl = itin.documents.find(doc => doc.id === dailyBgNodeId)?.file?.httpsUrl;

    const bg = document.getElementById("bg-layer");
    if (dailyBgUrl) applyBackgroundImage(bg, dailyBgUrl, itin.homeScreenPhotoDarkening);

    return () => {
      if (dailyBgUrl && mainBgUrl) applyBackgroundImage(bg, mainBgUrl, itin.homeScreenPhotoDarkening);
    };
  }, [dailyBgNodeId, itin.backgroundNodeId, itin.documents, itin.homeScreenPhotoDarkening, itin?.photoNode?.file?.httpsUrl])

  if (!data) return <div>Loading</div>;

  return <DocumentViewerScreen type="dailyDocuments" dailyData={data} />
};

export default DocumentViewer;